export enum DataType {
  FreeText = 1,
  // eslint-disable-next-line id-blacklist
  Number,
  List,
  Percentage,
  Date,
  Datetime,
  // eslint-disable-next-line id-blacklist
  Boolean,
}

enum AdditionalDataType {
  Formula = 10,
}

export type ExtendedDataType = DataType | AdditionalDataType;
export const ExtendedDataType = { ...DataType, ...AdditionalDataType };

export const DataTypeSelection: { id: DataType; name: string }[] = [
  {
    id: DataType.FreeText,
    name: $localize`:@@shared.dataType.txtFreeText:Free Text`,
  },
  { id: DataType.Number, name: $localize`:@@shared.dataType.txtNumber:Number` },
  { id: DataType.List, name: $localize`:@@shared.dataType.txtList:List` },
  {
    id: DataType.Percentage,
    name: $localize`:@@shared.dataType.txtPercent:Percentage`,
  },
  {
    id: DataType.Date,
    name: $localize`:@@shared.dataType.txtDate:Date`,
  },
  {
    id: DataType.Datetime,
    name: $localize`:@@shared.dataType.txtDateTime:Datetime`,
  },
  {
    id: DataType.Boolean,
    name: $localize`:@@shared.dataType.txtBoolean:Boolean`,
  },
];

export const ExtendedDataTypeSelection: {
  id: ExtendedDataType;
  name: string;
}[] = [
  ...DataTypeSelection,
  {
    id: ExtendedDataType.Formula,
    name: $localize`:@@shared.dataType.txtFormula:Formula`,
  },
];
